"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reviews = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = require("../Box/Box");

var _Column = require("../Column/Column");

var _Header = require("../Header/Header");

var _Row = require("../Row/Row");

var _StarRating = require("../StarRating/StarRating");

var _Text = require("../Text/Text");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Case = _interopRequireDefault(require("../Case/Case"));

var _ReviewsSingle = _interopRequireDefault(require("./ReviewsSingle.gentux"));

var _ReviewsSingle2 = _interopRequireDefault(require("./ReviewsSingle.menguin"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
} // Component


var Reviews =
/*#__PURE__*/
function (_Component) {
  _inherits(Reviews, _Component);

  function Reviews() {
    _classCallCheck(this, Reviews);

    return _possibleConstructorReturn(this, _getPrototypeOf(Reviews).apply(this, arguments));
  }

  _createClass(Reviews, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          reviews = _this$props.reviews,
          totalReviewCount = _this$props.totalReviewCount,
          averageStarRating = _this$props.averageStarRating,
          customFields = _this$props.customFields,
          loadMoreClicked = _this$props.loadMoreClicked,
          canLoadMore = _this$props.canLoadMore,
          displaySidebar = _this$props.displaySidebar;
      return _react.default.createElement(_Row.Row, {
        full: true,
        fullSm: true
      }, displaySidebar && _react.default.createElement(_Column.Column, {
        columnMd: 4
      }, _react.default.createElement(_Box.Box, {
        p: 4,
        backgroundColor: "white",
        mb: 4
      }, _react.default.createElement(_Box.Box, null, _react.default.createElement(_Header.Header, {
        headline: true,
        type: 2,
        mb: 3
      }, "Customer Reviews"), _react.default.createElement(_Header.Header, {
        type: 4,
        mb: 1
      }, "Overall"), _react.default.createElement(_StarRating.StarRating, {
        rating: averageStarRating
      }), _react.default.createElement(_Text.Text, {
        inline: true,
        small: true,
        textColor: "muted"
      }, "(", totalReviewCount, "\xA0reviews)")))), _react.default.createElement(_Column.Column, {
        columnMd: displaySidebar ? 8 : 12
      }, reviews.map(function (review, i) {
        return _react.default.createElement(_react.Fragment, {
          key: review.id
        }, _react.default.createElement(_Case.default, {
          brand: "menguin"
        }, _react.default.createElement(_ReviewsSingle2.default, {
          customFields: customFields,
          review: review
        })), _react.default.createElement(_Case.default, {
          brand: "gentux"
        }, _react.default.createElement(_ReviewsSingle.default, {
          customFields: customFields,
          review: review,
          isLastElement: reviews.length === i + 1
        })));
      }), canLoadMore && _react.default.createElement(_Button.default, {
        buttonType: "info",
        onClick: loadMoreClicked,
        mt: 4
      }, "Load More")));
    }
  }]);

  return Reviews;
}(_react.Component);

exports.Reviews = Reviews;
Reviews.displayName = 'Reviews'; // Prop Types

Reviews.propTypes = {
  reviews: _propTypes.default.array.isRequired,
  averageStarRating: _propTypes.default.number.isRequired,
  totalReviewCount: _propTypes.default.number.isRequired,
  customFields: _propTypes.default.array,
  canLoadMore: _propTypes.default.bool,
  loadMoreClicked: _propTypes.default.func,
  displaySidebar: _propTypes.default.bool
};
Reviews.defaultProps = {
  canLoadMore: false,
  loadMoreClicked: function loadMoreClicked() {},
  customFields: undefined,
  displaySidebar: true
};